module.exports = __webpack_public_path__ + "media/images/spinner-988e0b9c075c56bdcf6c8e58670414c7.gif";